import generatedPossibleTypes from '../../__generated__/possibleTypes';

export const { possibleTypes } = generatedPossibleTypes;
